// src/config.js
const isProduction = process.env.NODE_ENV === 'production';

const config = {
  // En producción (Vercel) usa el proxy local, en desarrollo usa el API directo
  apiBaseUrl: isProduction ? '/api/proxy' : (process.env.REACT_APP_API_BASE_URL || "https://api.kibo.aventiscali.com"),
  apiKey: process.env.REACT_APP_API_KEY || "",
  n8nWebhookBase: process.env.REACT_APP_N8N_WEBHOOK_BASE || "https://n8n-n8n-zgfy7o.aventiscali.com",
  n8nContactosPath: "/webhook/listarContactos",
  n8nAlertasPath: "/webhook/listarAlertar",
  isProduction,
};

export default config;